const getShowNotice = state => state.notice.showNotice;
const getNoticeMessage = state => state.notice.message;
const getNoticeResponse = state => state.notice.response;

export { getShowNotice, getNoticeMessage, getNoticeResponse };
